<template>
  <div
    fluid
    class="
      reportPage
      row
      content-start
      bg-primary
      full-width
      solutionsDatabase
      q-py-md q-px-lg
    "
    style="min-height: calc(100vh - 60px)"
  >
    <!-- Title -->
    <div class="col-12">
      <h5 class="q-my-md q-px-md text-white text-weight-bolder">
        Report your monthly data
      </h5>
    </div>

    <!-- Sections -->
    <div class="col-12 col-md-3 q-px-md">
      <!-- Sections list -->
      <q-card class="q-pa-md customRounded">
        <q-scroll-area
          class="customScrollArea"
          :thumb-style="{
            background: '#162c479c',
            opacity: 1,
            width: '8px',
            height: '8px',
            borderRadius: '20px',
          }"
        >
          <!-- Title -->
          <div class="col-12 q-pa-sm">
            <p class="text-accent q-my-none">Report Period:</p>
            <h6 class="text-weight-bolder q-my-sm">Upstream</h6>
            <p class="text-accent q-my-none">
              Please finish inputting the following before you submit
            </p>
          </div>

          <!-- Section cards -->
          <div
            class="col-12 row wrap q-pa-sm"
            v-for="(section, i) in sections"
            :key="i"
          >
            <div class="row wrap justify-start full-width">
              <div
                class="
                  col-12
                  bg-white
                  text-accent text-center
                  customRounded
                  customBorder
                  cursor-pointer
                  q-pa-sm
                "
              >
                <div class="row items-center justify-between">
                  <p class="text-accent text-weight-bolder text-left q-my-none">
                    {{ section.name }}
                  </p>
                  <q-btn
                    round
                    :class="{
                      'bg-positive': section.finished,
                      'bg-grey': !section.finished,
                    }"
                    size="6px"
                    v-model="section.finished"
                  >
                    <q-icon color="white" size="14px" name="check"></q-icon>
                  </q-btn>

                  <q-separator class="full-width q-my-sm" />
                  <a
                    class="text-accent col-12 text-left"
                    @click="setSection(section.id)"
                    href="#"
                    >Edit</a
                  >
                </div>
              </div>
            </div>
          </div>
        </q-scroll-area>
      </q-card>
    </div>

    <!-- Sources & Datatypes -->

    <div v-if="currentSection" class="col-12 col-md-6 q-px-md">
      <q-card class="q-pa-md customRounded">
        <q-scroll-area
          class="customScrollArea"
          :thumb-style="{
            background: '#162c479c',
            opacity: 1,
            width: '8px',
            height: '8px',
            borderRadius: '20px',
          }"
        >
          <!-- Title -->
          <div class="col-12 q-pa-sm">
            <h6 class="text-weight-bolder q-my-sm">
              {{ currentSection.name }}
            </h6>
          </div>

          <!-- Section cards -->

          <div
            class="col-12 row wrap q-pa-sm"
            v-for="(source, sourceIndex) in filteredSourcesByLive"
            :key="sourceIndex"
          >
            <div class="row wrap justify-start full-width">
              <div
                class="
                  col-12
                  bg-white
                  text-accent text-center
                  customRounded
                  customBorder
                  cursor-pointer
                  q-pa-sm
                "
              >
                <div class="row items-center justify-between">
                  <!--Card Heading-->
                  <div
                    class="row full-width"
                    v-on:click="toggleCard(sourceIndex)"
                  >
                    <div class="col">
                      <p
                        class="
                          text-accent text-weight-bolder text-left
                          q-my-none
                        "
                      >
                        {{ currentSection.name }} source: {{ source.name }}
                      </p>
                    </div>
                    <div class="col">
                      <q-btn
                        round
                        :class="{
                          'float-right': true,
                          'bg-positive': sourceList[sourceIndex].isFilled,
                          'bg-grey': !sourceList[sourceIndex].isFilled,
                        }"
                        size="6px"
                        v-model="source.finished"
                      >
                        <q-icon color="white" size="14px" name="check"></q-icon>
                      </q-btn>
                    </div>
                  </div>
                  <!-----Card Heading End-------->

                  <q-separator class="full-width q-my-sm" />

                  <transition-group
                    name="expand"
                    mode="out-in"
                    class="full-width"
                  >
                    <!-- Datatypes list here -->
                    <div
                      v-show="sourceList[sourceIndex].toggleCard"
                      class="row items-center justify-center"
                      v-for="(datatype, datatypeIndex) in getDatatypes(
                        source.id
                      )"
                      :key="datatypeIndex"
                    >
                      <div class="col">
                        <p class="text-accent q-my-none q-mx-sm text-right">
                          {{ datatype.name }}
                        </p>
                      </div>
                      <div class="col-8">
                        <q-input
                          @blur="onDatatypeFieldUpdate(sourceIndex)"
                          v-model="
                            sourceList[sourceIndex].dataList[datatypeIndex].data
                          "
                          height="20px"
                          class="q-mx-sm q-my-xs"
                          filled
                          dense
                        ></q-input>
                      </div>
                      <div class="col full-width">
                        <p
                          class="text-accent text-left q-my-none q-mx-sm"
                          style="
                            max-width: 60px;
                            white-space: no-wrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                          "
                        >
                          {{ datatype.unit }}
                          <q-icon
                            color="grey"
                            class="q-mx-auto float-right"
                            style="font-size: 15px"
                            name="help"
                          >
                            <q-tooltip>{{ datatype.help_text }}</q-tooltip>
                          </q-icon>
                        </p>
                      </div>
                    </div>
                  </transition-group>
                  <a
                    class="text-accent col-12 text-left"
                    href="#"
                    style="z-index: 99; width: 20px"
                    @click="toggleCard(sourceIndex)"
                    >Edit</a
                  >
                </div>
              </div>
            </div>
          </div>
        </q-scroll-area>
      </q-card>
    </div>

    <!-- Next, Save, Submit -->
    <div class="col-12 col-md-3 q-px-md">
      <q-card class="customRounded full-height">
        <!-- <q-scroll-area
          class="customScrollArea"
          :thumb-style="{
              background: '#162c479c',
              opacity: 1,
              width: '8px',
              height: '8px',
              borderRadius: '20px',
            }"
        >

        </q-scroll-area> -->

        <div class="row full-height full-width text-center">
          <div class="col-12 q-mt-xl">
            <q-btn
              color="primary"
              class="text-capitalize q-pl-md q-pr-md q-mt-xl"
            >
              Next
            </q-btn>
          </div>
        </div>

        <div style="position: absolute; bottom: 0">
          <div
            class="row justify-center content-between q-pa-md q-col-gutter-sm"
          >
            <div class="col-12">
              <div class="q-mt-none text-caption">
                Please finish inputting the following before you submit
              </div>
            </div>
            <div class="col-6">
              <q-btn color="accent" class="text-capitalize full-width"
                >Save</q-btn
              >
            </div>
            <div class="col-6">
              <q-btn color="accent" class="text-capitalize full-width"
                >Submit</q-btn
              >
            </div>
          </div>
        </div>
      </q-card>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    components: {},
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        sections: "sections/list",
        sources: "sectionSources/list",
        datatypes: "datatypes/list",
      }),
      // filters sources by the status == live
      filteredSourcesByLive() {
        return this.sources.filter((e) => e.status == "live");
      },
    },
    watch: {
      $route: function () {},
    },
    data: () => ({
      sourceList: [],
      currentSectionIndex: 0,
      currentSection: null,
      currentSource: {},
      currentDatatype: null,
      search: "",
      editSourceDialog: false,
      newSourceDialog: false,
      showDatatypesForm: false,
      editDatatypeForm: false,
      formData: {},
      sourceColumns: [
        {
          name: "name",
          label: "Name",
          align: "left",
          field: "name",
          sortable: true,
        },
        {
          name: "info",
          label: "Info",
          align: "left",
          field: "info",
        },
        {
          name: "finished",
          label: "Finished",
          align: "left",
          field: "finished",
          format: (val) => {
            if (val) {
              return "True";
            }
            return "False";
          },
        },
      ],
      datatypeColumns: [
        {
          name: "name",
          label: "Name",
          align: "left",
          field: "name",
          sortable: true,
        },

        {
          name: "unit",
          label: "Unit",
          align: "left",
          field: "unit",
        },
      ],
    }),
    beforeCreate() {
      this.$store.dispatch("sections/loadAll");
      this.$store.dispatch("datatypes/loadAll");
      // this.$store.dispatch("sectionSources/loadAllForSection", 1);
      // this.$store.dispatch("datatypes/loadAllForSource", 1);
    },
    async mounted() {
      await this.init();
      this.initialiseSourceList();
    },
    methods: {
      toggleCard(index) {
        this.sourceList[index].toggleCard = !this.sourceList[index].toggleCard;
      },
      onDatatypeFieldUpdate(index) {
        this.sourceList[index].dataList.forEach((e) => {
          let isFilled = true;
          if (!e.data || e.data == "") {
            isFilled = false;
          }
          this.sourceList[index].isFilled = isFilled;
        });
      },
      initialiseSourceList() {
        this.sourceList = [];
        let newSourceList = [];
        this.sources.forEach((e) => {
          let dataTypeList = this.datatypes.filter(
            (data) => data.source_id == e.id
          );
          let payload = {
            toggleCard: false,
            sourceName: e.name,
            isFilled: false,
            dataList: [],
          };
          dataTypeList.forEach((currentData) => {
            payload.dataList.push({
              dataName: currentData.name,
              data: null,
            });
          });
          newSourceList.push(payload);
        });
        this.sourceList = newSourceList;
      },
      async init() {
        await this.setSection(this.sections[this.currentSectionIndex].id);
      },
      async setSection(id) {
        await this.$store.dispatch("sectionSources/loadAllForSection", id);
        this.initialiseSourceList();
        this.currentSection = this.sections.find((e) => e.id == id);
      },

      saveSection() {
        this.$emit("loadingStateChanged", true);
        setTimeout(() => {
          this.currentSection.finished = this.currentSection.finished ? 1 : 0;
          this.$store
            .dispatch("sections/save", this.currentSection)
            .then((result) => {
              this.$emit("loadingStateChanged", false);
              if (result.Result == "Success") {
                this.$store.dispatch("sections/loadAll");
                this.$emit("close", true);
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message,
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an Error, Please try again later",
                });
              }
            });
        });
      },

      formSubmit(e) {
        if ((e.code == "Enter" || e.code == "NumpadEnter") && e.ctrlKey) {
          this.create();
        }
      },

      handleDoubleClick(row) {
        this.editSourceDialog = true;
        this.currentSource = row;
        this.$store.dispatch("datatypes/loadAllForSource", row.id);
      },

      getDatatypes(sourceId) {
        // Inefficient
        let test = this.datatypes.filter((obj) => {
          return obj.source_id == sourceId;
        });
        return test;
      },

      editDatatype(row) {
        this.currentDatatype = row;
        this.editDatatypeForm = true;
      },

      createDatatype() {
        this.$emit("loadingStateChanged", true);
        setTimeout(() => {
          this.formData.source_id = this.currentSource.id;

          this.$refs.dtAddForm.validate().then((result) => {
            if (result) {
              this.$store
                .dispatch("datatypes/new", this.formData)
                .then((result) => {
                  this.$emit("loadingStateChanged", false);
                  if (result.Result == "Success") {
                    this.$store.dispatch(
                      "datatypes/loadAllForSource",
                      this.currentSource.id
                    );
                    this.$emit("close", true);
                    this.showDatatypesForm = false;
                    this.formData = {};
                    this.$q.notify({
                      position: "top-right",
                      type: "positive",
                      message: result.Response.Message,
                    });
                  } else {
                    this.$q.notify({
                      position: "top-right",
                      type: "negative",
                      message: "There was an Error, Please try again later",
                    });
                  }
                });
            }
          });
        }, 200);
      },

      saveDatatype() {
        this.$emit("loadingStateChanged", true);
        setTimeout(() => {
          this.$refs.dtEditForm.validate().then((result) => {
            if (result) {
              this.$store
                .dispatch("datatypes/save", this.currentDatatype)
                .then((result) => {
                  this.$emit("loadingStateChanged", false);
                  if (result.Result == "Success") {
                    this.$store.dispatch(
                      "datatypes/loadAllForSource",
                      this.currentSource.id
                    );
                    this.$emit("close", true);
                    this.editDatatypeForm = false;
                    this.$q.notify({
                      position: "top-right",
                      type: "positive",
                      message: result.Response.Message,
                    });
                  } else {
                    this.$q.notify({
                      position: "top-right",
                      type: "negative",
                      message: "There was an Error, Please try again later",
                    });
                  }
                });
            }
          });
        });
      },

      deleteDatatype() {
        this.$emit("loadingStateChanged", true);
        setTimeout(() => {
          this.$store
            .dispatch("datatypes/delete", this.currentDatatype)
            .then((result) => {
              this.$emit("loadingStateChanged", false);
              if (result.Result == "Success") {
                this.$store.dispatch(
                  "datatypes/loadAllForSource",
                  this.currentSource.id
                );
                this.$emit("close", true);
                this.editDatatypeForm = false;
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message,
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an Error, Please try again later",
                });
              }
            });
          this.setSection();
        });
      },

      saveSource() {
        this.$emit("loadingStateChanged", true);
        setTimeout(() => {
          this.currentSource.finished = this.currentSource.finished ? 1 : 0;
          this.$store
            .dispatch("sectionSources/save", this.currentSource)
            .then((result) => {
              this.$emit("loadingStateChanged", false);
              if (result.Result == "Success") {
                this.$store.dispatch(
                  "sectionSources/loadAllForSection",
                  this.currentSection.id
                );
                this.$emit("close", true);
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message,
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an Error, Please try again later",
                });
              }
            });
        });
      },

      deleteSource() {
        this.$emit("loadingStateChanged", true);
        setTimeout(() => {
          this.$store
            .dispatch("sectionSources/delete", this.currentSource)
            .then((result) => {
              this.$emit("loadingStateChanged", false);
              if (result.Result == "Success") {
                this.$store.dispatch(
                  "sectionSources/loadAllForSection",
                  this.currentSection.id
                );
                this.editSourceDialog = false;
                this.$emit("close", true);
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message,
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an Error, Please try again later",
                });
              }
            });
          this.setSection();
        });
      },
    },
  };
</script>

<style lang="scss">
  .reportPage {
    h6 {
      font-size: 14px;
    }

    p {
      font-size: 10px;
    }

    a {
      font-size: 9px;
    }

    .dtDialog {
      max-width: 1000px;
      margin: auto;
    }
    .customRounded {
      border-radius: 10px;
    }
    .customBorder {
      border: 0.6px solid #e0e0e0;
    }
    .customScrollArea {
      height: calc(100vh - 210px);
    }

    .q-field__control {
      height: 22px !important;
    }
    .expand-enter-active,
    .expand-leave-active {
      transition: all 0.2s;
      max-height: 800px;
    }
    .expand-enter,
    .expand-leave-to {
      opacity: 0;
      max-height: 0px;
    }
  }
</style>
